import React from 'react';
import { Routes, Route, NavLink, useLocation } from 'react-router-dom';
import SimuladorRateioView from './SimuladorRateioView';
import DashboardRateioView from './DashboardRateioView';
import AncoraView from './AncoraView';
import ConciliacaoView from './ConciliacaoView';
import DistribuidorasView from './DistribuidorasView';

const TABS = [
  { to: '', label: 'Simulador' },
  { to: 'dashboard', label: 'Dashboard' },
  { to: 'ancora', label: 'Unidade Âncora' },
  { to: 'conciliacao', label: 'Conciliação' },
  { to: 'distribuidoras', label: 'Distribuidoras' },
];

const RateioLayout: React.FC = () => {
  const location = useLocation();
  const basePath = '/gestao/rateio';

  return (
    <div className="space-y-4 animate-fade-in">
      <div className="flex bg-gray-200 dark:bg-gray-700 p-1 rounded-lg w-fit">
        {TABS.map(tab => {
          const target = tab.to ? `${basePath}/${tab.to}` : basePath;
          const active = tab.to
            ? location.pathname === target
            : location.pathname === basePath || location.pathname === `${basePath}/`;
          return (
            <NavLink
              key={tab.to}
              to={target}
              end
              className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
                active
                  ? 'bg-white dark:bg-gray-800 text-primary shadow'
                  : 'text-gray-500 dark:text-gray-400 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </NavLink>
          );
        })}
      </div>

      <Routes>
        <Route index element={<SimuladorRateioView />} />
        <Route path="dashboard" element={<DashboardRateioView />} />
        <Route path="ancora" element={<AncoraView />} />
        <Route path="conciliacao" element={<ConciliacaoView />} />
        <Route path="distribuidoras" element={<DistribuidorasView />} />
      </Routes>
    </div>
  );
};

export default RateioLayout;
